module.exports = __webpack_public_path__ + "static/media/lmc.4f155723.png";